module.exports = __webpack_public_path__ + "df76a9f1dfca58317dbfeb0ce804fbe6.jpg";